module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/iMac-af517db38491f0061ecb962a520ea633.svg";